import {useEffect, useRef, useState} from "react";

// services
import {paramSettingsService} from "../jwt/_services/hotel/paramsSettingsService";

const useParamSetting = param => {

    const [loading, setLoading] = useState( false )
    const [paramSetting, setParamSetting] = useState(null)
    const [message, setMessage] = useState('')

    const isMounted = useRef(true)

    useEffect(() => {
        if( param )
            searchParams()

        return () => {
            isMounted.current = false
        }
    }, [param]);

    const searchParams = () => {

        setLoading(true)

        paramSettingsService
            .search(0,10, { item:{ ps_key: param } } )
            .then( res => {
                if(!isMounted.current)
                    return

                if(res?.data.length <= 0){
                    setMessage('No se encontró el parámetro solicitado')
                    return
                }

                setParamSetting( res?.data[0] )
                setMessage(null)
            })
            .catch( err => console.error(err) )
            .finally( () => {
                if(!isMounted.current)
                    return
                setLoading(false)
            } )
    }


    return {
        loading,
        message,
        paramSetting
    }
}

export default useParamSetting